import { Component, Context, ContextType, PropsWithChildren } from 'react';

import utils from '../utils';

import type { LegacyContext } from './LegacyContextType';
import { AuthContext } from './Router';

export default class NotAuthenticated extends Component<PropsWithChildren, Record<string, never>> {
  static contextType: Context<LegacyContext> = AuthContext;
  context!: ContextType<typeof AuthContext>;

  render() {
    const { user, loading } = this.context;
    const { children } = this.props;
    const authenticated = !!user;
    const propsToForward = utils.excludeProps(['inGroup'], this.props);

    return !authenticated && !loading ? utils.enforceRootElement(children, propsToForward) : null;
  }
}
